import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import pure from 'recompose/pure'
import ColorText from 'components/ColorText'

const Quote = ({ quote, author, likes, tags, pk, image, ...props }) => (
  <Typography variant="caption" noWrap {...props} className="quote-row">
    {quote} - <ColorText color="#ff8c39">{author}</ColorText>
  </Typography>
)

Quote.propTypes = {
  quote: PropTypes.string,
  author: PropTypes.string,
  likes: PropTypes.number,
  tags: PropTypes.array,
  pk: PropTypes.number,
  image: PropTypes.any,
}

export default pure(Quote)



// WEBPACK FOOTER //
// ./src/cms/widgets/QuotePicker/Quote.js